import { LegalPage } from "@/components/LegalPage";

export default function Terms() {
  return <LegalPage endpoint="terms" heading="Terms & Conditions" title="Terms & Conditions" />;
}
